import { SVGAttributes } from 'react';

export default function ArrBottomSVG(props: SVGAttributes<SVGElement>) {
    return (
        <svg
            {...props}
            className="icon"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M12.05 13.605L16.15 9.50503C16.3334 9.3217 16.5459 9.23003 16.7875 9.23003C17.0292 9.23003 17.2417 9.3217 17.425 9.50503C17.6084 9.68836 17.7 9.90086 17.7 10.1425C17.7 10.3842 17.6055 10.5995 17.4165 10.7885L12.675 15.53C12.585 15.6134 12.4875 15.6759 12.3825 15.7175C12.2775 15.7592 12.165 15.78 12.045 15.78C11.925 15.78 11.8125 15.7592 11.7075 15.7175C11.6025 15.6759 11.5084 15.6134 11.425 15.53L6.68353 10.7885C6.49453 10.5995 6.40002 10.3842 6.40002 10.1425C6.40002 9.90086 6.49169 9.68836 6.67502 9.50503C6.85836 9.3217 7.07086 9.23003 7.31252 9.23003C7.55419 9.23003 7.76669 9.3217 7.95002 9.50503L12.05 13.605Z" />
        </svg>
    );
}
